import { render } from "./Forbidden403.vue?vue&type=template&id=37359f24&scoped=true"
const script = {}

import "./Forbidden403.vue?vue&type=style&index=0&id=37359f24&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./Forbidden403.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37359f24"]])

export default __exports__